import { useNavigate } from 'react-router-dom';

import { useQuery } from '@tanstack/react-query';

import { getTrainingVideoOptions } from 'api/Wizard/Wizard';

export const useTrainingVideoOptions = ({ params = {}, options = {}, dependencies = [] } = {}) => {
  const navigate = useNavigate();

  return useQuery({
    queryKey: ['training-video-options', ...dependencies],
    queryFn: () => getTrainingVideoOptions(navigate, params),
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    staleTime: 5 * 60 * 1000,
    ...options
  });
};
